<script lang="ts">
  import Badge from "$lib/ui/badge/badge.svelte";
  import { mapSeverityColour } from "../../utils/securityFindings";
  import { toTitleCase } from "$lib/utils/text";
  import type { SecurityFinding } from "$lib/stores/orgSecurityFindings";

  let { finding } = $props<{ finding: SecurityFinding }>();
</script>

<Badge color={mapSeverityColour(finding.severityLevel)}>
  {toTitleCase(finding.severityLevel)}
</Badge>
